import { authStorage } from '../platform/storage';
import { limitNativeSessionExpiry } from '../platform/sessionTestLimit.mjs';
import { resolveExpiryTimestamp } from '../platform/sessionState.mjs';

export const saveToken = async (token, expiryTime=3600, credentials = {}) => {
    const expiryTimestamp = resolveExpiryTimestamp(expiryTime);
    if (authStorage.saveSession) {
        return await authStorage.saveSession(token, limitNativeSessionExpiry(
            expiryTimestamp, import.meta.env.MODE, import.meta.env.VITE_NATIVE_SESSION_TEST_SECONDS
        ), credentials);
    }
    await Promise.all([
        authStorage.set('token', token),
        authStorage.set('expiryTimestamp', expiryTimestamp)
    ]);

    // Set a timeout for 5 minutes before the token expires
    // const notifyBeforeExpiry = expiryTime - 300; // 300 seconds = 5 minutes
    // setTimeout(() => { Commenting out for now until I get toasts to work properly
    //     toast.warn('Your session will expire in 5 minutes. Please refresh or re-login to avoid being logged out.', {
    //         position: "top-right",
    //         autoClose: 30000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //     });
    // }, notifyBeforeExpiry * 1000);
};

export const isTokenExpired = async () => {
    const expiryTimestamp = await authStorage.get('expiryTimestamp');
    if (!expiryTimestamp) return false;
    return new Date().getTime() > expiryTimestamp;
};

export const clearSession = () => authStorage.clearAuth();
